import React from "react";
import Users from "./Users";
import Chargers from "./Chargers";
import Sessions from "./Sessions";
import Transactions from "./Transactions";
import Notifications from "./Notifications";

function Dashboard() {
  return (
    <div className="dashboard-container">
      <h1>EV Dashboard Overview</h1>
      <Users />
      <Chargers />
      <Sessions />
      <Transactions />
      <Notifications />
    </div>
  );
}

export default Dashboard;
